import { Box, IconButton } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { InputField } from 'components/form';
import { FinanceProgramFormValues } from 'modules/desking/types';
import { useLazyQuery } from '@apollo/client';
import { DECODE_VIN_VALUES } from 'modules/desking/api';
import SearchIcon from '@mui/icons-material/Search';
import { useNotifications } from 'modules/notification';

interface Props {
  inputFieldProps?: any;
  isSearchIconHidded?: boolean;
  onResponse: (result: any) => void;
}

export const SerialNumberVinInput = ({ inputFieldProps, isSearchIconHidded, onResponse }: Props) => {
  const { showNotification } = useNotifications();

  const { control, getValues } = useFormContext<FinanceProgramFormValues>();

  const serialNumberVin = useWatch({
    control,
    name: 'equipment.serialNumberVin',
  });

  const [decodeVinValues, { loading }] = useLazyQuery(DECODE_VIN_VALUES);

  const handleSearch = async () => {
    try {
      const response = await decodeVinValues({ variables: { vin: getValues('equipment.serialNumberVin') } });
      onResponse(response.data?.decodeVinValues);
    } catch (error) {
      showNotification('An error occurred', { type: 'error' });
    }
  };

  return (
    <Box display="flex" alignItems="center">
      <InputField control={control} label="Serial/VIN#" name="equipment.serialNumberVin" {...inputFieldProps} />
      {!isSearchIconHidded && (
        <IconButton
          type="button"
          color="primary"
          className="icon-btn-bordered"
          sx={{ ml: 1 }}
          size="small"
          onClick={handleSearch}
          loading={loading}
          disabled={!serialNumberVin.length}
        >
          <SearchIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};
